import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { AUTOMATION_QUERY_KEYS, AUTOMATION_TEMPLATE_MUTATION_KEY } from '../../queryKeys';
import type { BehaviorSwitchStepPayload } from './types';

interface Params {
	templateId: string;
	stepId: string;
	caseId: string;
	impersonationContext?: Api.IImpersonationContext;
}

export function useRemoveBehaviorCaseMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: BehaviorSwitchStepPayload, variables: Params) => void;
	onError?: (error: Api.IOperationResultNoValue, variables: Params) => void;
} = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation({
		mutationKey: AUTOMATION_TEMPLATE_MUTATION_KEY,
		mutationFn: ({ templateId, stepId, caseId, impersonationContext }: Params) => {
			return userSession.webServiceHelper.callAsync<BehaviorSwitchStepPayload>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/BehaviorSwitch/${encodeURIComponent(
						stepId
					)}/Case/${encodeURIComponent(caseId)}`,
					impersonationContext,
				}),
				'DELETE',
				null
			);
		},
		onSuccess: (data, variables) => {
			queryClient.invalidateQueries({ queryKey: AUTOMATION_QUERY_KEYS.template(variables.templateId) });
			onSuccess?.(data, variables);
		},
		onError,
	});
}
